import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { Translate } from "react-redux-i18n";
import Form from "react-bootstrap/Form";
import {
  login,
  loginBusiness,
  loginAdmin,
  checkAdmin,
  updateVerifyEditedAccountState,
} from "../../../actions/accountActions";
import { setAlert } from "../../../actions/alertActions";
import { Tabs, Tab } from "react-bootstrap";
import SelectUser from "./modals/SelectUser";
import { selectCountry } from "../../utils/Utils";
import { fetchTranslationV2 } from "../../../actions/languageActions";
import "../../../styles/components/account/login/Login.scss";
import "react-phone-input-2/lib/style.css";
import evio from "../../../styles/images/evio.svg";

class Login extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      country: "",
      prefix: "",
      phone: this.props.mobile || "",
      key: this.props.hasOwnProperty("admin") ? "admin" : "business",
      businessValidated: false,
      validated: false,
      usersList: [],
      pack: {},

      modals: {
        selectUser: false,
      },
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleBusinessLogin = this.handleBusinessLogin.bind(this);
    this.handleAdminLogin = this.handleAdminLogin.bind(this);
    this.checkCredentials = this.checkCredentials.bind(this);
  }

  componentDidMount() {
    this._mounted = true;

    this.safeSetState(
      {
        country: selectCountry(this.props.locale),
      },
      () => {
        if (this.props.mobile)
          this.safeSetState({
            prefix: this.props.internationalPrefix.replace("+", ""),
            phone: this.props.internationalPrefix + this.props.mobile,
          });
      }
    );
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  handleUsernameChange(e, obj) {
    this.safeSetState({
      prefix: obj.dialCode,
      phone: e,
    });
  }

  handleLogin(e, isWhiteLabel = false) {
    e.preventDefault();

    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        const username = this.state.phone
          .replace(/[^0-9]+/g, "")
          .slice(this.state.prefix.length);
        const password = document.getElementsByName("password")[0].value;

        this.props.login(
          "+" + this.state.prefix,
          username,
          password,
          isWhiteLabel
        );
      }
    });
  }

  handleBusinessLogin(e, isWhiteLabel = false) {
    e.preventDefault();

    const form = $(e.target)[0];
    this.safeSetState({ businessValidated: true }, () => {
      if (form.checkValidity() !== false) {
        const email = document.getElementsByName("email")[0].value;
        const password =
          document.getElementsByName("businessPassword")[0].value;
        this.props.updateVerifyEditedAccountState({
          verifyEditedAccount: false,
          tempEmail: document.getElementsByName("email")[0].value,
          changedEmail: false,
        });

        this.props.loginBusiness(email, password, isWhiteLabel);
      }
    });
  }

  checkCredentials(username, password) {
    const packet = {
      password: password,
      username: username,
    };

    axios
      .post("/api/adminUser/authenticate", packet)
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              usersList: res.data,
              pack: { ...packet },
            },
            () => this.setModal("selectUser", true)
          );
        }
      })
      .catch((err) => console.log(err));
  }

  handleAdminLogin(e, isWhiteLabel = false) {
    e.preventDefault();

    const form = $(e.target)[0];
    this.safeSetState({ businessValidated: true }, () => {
      if (form.checkValidity() !== false) {
        const username = document.getElementsByName("username")[0].value;
        const password = document.getElementsByName("adminPassword")[0].value;
        const clientEmail = document.getElementsByName("clientEmail")[0].value;

        if (clientEmail === "") {
          this.checkCredentials(username, password, isWhiteLabel);
        } else {
          this.props.loginAdmin(username, password, clientEmail, isWhiteLabel);
        }
      }
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="login" className="evio-container">
        <div className="sidemenu">
          <div className="logo-container">
            <img
              src={this.props.brand?.icons?.logo || evio}
              alt={`${this.props.brand?.brandName} logo`}
            />
          </div>

          {this.props.hasOwnProperty("admin") ? (
            <div className="form-admin-container">
              <div className="form-container">
                <Form
                  id="login-admin-form"
                  validated={this.state.businessValidated}
                  noValidate
                  onSubmit={(e) =>
                    this.handleAdminLogin(
                      e,
                      (this.props.brand?.brandName ?? "EVIO") !== "EVIO"
                    )
                  }
                >
                  <Form.Group className="form-field">
                    <Form.Control
                      tabIndex="2"
                      type="text"
                      name="username"
                      placeholder="User Name"
                      value="admin"
                      disabled
                      required
                    />
                  </Form.Group>
                  <Form.Group className="form-field">
                    <Form.Control
                      tabIndex="3"
                      type="password"
                      name="adminPassword"
                      placeholder="Admin Password"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="form-field" controlId="email">
                    <Form.Control
                      tabIndex="1"
                      type="email"
                      name="clientEmail"
                      placeholder="Client E-mail"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    />
                  </Form.Group>
                </Form>

                <SelectUser
                  show={this.state.modals.selectUser}
                  listOfUsers={this.state.usersList}
                  packet={this.state.pack}
                  onHide={() => this.setModal("selectUser", false)}
                  onSubmit={(e) =>
                    this.handleAdminLogin(
                      e,
                      (this.props.brand?.brandName ?? "EVIO") !== "EVIO"
                    )
                  }
                />
              </div>

              <div className="footer-container">
                <button
                  type="submit"
                  form="login-admin-form"
                  onSubmit={(e) =>
                    this.handleAdminLogin(
                      e,
                      (this.props.brand?.brandName ?? "EVIO") !== "EVIO"
                    )
                  }
                  disabled={this.state.modals.selectUser === true}
                >
                  <Translate value="login_login" />
                </button>

                {/* <p>
    <Translate value="login_dontHaveAccount" />
    <Link to="/createAccount" href="/createAccount" className="link">
      <Translate value="signUp_createAccount" />
    </Link>
  </p> */}
              </div>
            </div>
          ) : (
            <Tabs
              id="controlled-tab-example"
              activeKey={this.state.key}
              onSelect={(k) => this.safeSetState({ key: k })}
            >
              <Tab
                eventKey="business"
                title={<Translate value="backOffice_login_company" />}
              >
                <div className="form-container">
                  <Form
                    id="login-business-form"
                    validated={this.state.businessValidated}
                    noValidate
                    onSubmit={(e) =>
                      this.handleBusinessLogin(
                        e,
                        (this.props.brand?.brandName ?? "EVIO") !== "EVIO"
                      )
                    }
                  >
                    <Form.Group className="form-field" controlId="email">
                      <Form.Control
                        tabIndex="1"
                        type="text"
                        name="email"
                        placeholder="E-mail"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        required
                      />
                    </Form.Group>
                    <Form.Group className="form-field">
                      <Form.Control
                        tabIndex="3"
                        type="password"
                        name="businessPassword"
                        placeholder="Password"
                        required
                      />
                    </Form.Group>
                    <Form.Group className="form-field">
                      <p>
                        <Translate value="login_forgotPassword" />
                        <Link
                          to="/recoverPassword"
                          href="/recoverPassword"
                          className="link"
                        >
                          <Translate value="login_recover" />
                        </Link>
                      </p>
                    </Form.Group>
                  </Form>
                </div>

                <div className="footer-container">
                  <button type="submit" form="login-business-form">
                    <Translate value="login_login" />
                  </button>
                  {/* <p>
                  <Translate value="login_dontHaveAccount" />
                  <Link to="/createAccount" href="/createAccount" className="link">
                    <Translate value="signUp_createAccount" />
                  </Link>
                </p> */}
                </div>
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  internationalPrefix: state.account.accountData.internationalPrefix,
  mobile: state.account.accountData.mobile,
  country: state.i18n.locale,
  brand: state.app.brand,
});

export default connect(mapStateToProps, {
  login,
  loginBusiness,
  loginAdmin,
  checkAdmin,
  setAlert,
  updateVerifyEditedAccountState,
  fetchTranslationV2,
})(Login);
